var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SAText } from '../text';
var Horizontal = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var Vertical = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  * {\n    flex-basis: 100%;\n  }\n  .sa-label-value-value {\n    text-align: left;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  * {\n    flex-basis: 100%;\n  }\n  .sa-label-value-value {\n    text-align: left;\n  }\n"])));
var StyledGroup = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &.sa-label-value-group-vertical {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &.sa-label-value-group-horizontal {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-content: flex-start;\n  }\n"], ["\n  &.sa-label-value-group-vertical {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &.sa-label-value-group-horizontal {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-content: flex-start;\n  }\n"])));
function LabelValueHorizontal(_a) {
    var label = _a.label, children = _a.children;
    return (React.createElement(Horizontal, { className: "sa-label-value-horizontal" },
        React.createElement(SAText, { as: "h4", size: "100", weight: "bold" }, label),
        React.createElement(SAText, { as: "div", size: "300", weight: "normal" }, children)));
}
function LabelValueVertical(_a) {
    var label = _a.label, children = _a.children;
    return (React.createElement(Vertical, { className: "sa-label-value-vertical" },
        React.createElement(SAText, { as: "h4", size: "300", weight: "bold" }, label),
        React.createElement(SAText, { as: "div", size: "300", weight: "normal" }, children)));
}
export function SALabelValueGroup(_a) {
    var children = _a.children, variant = _a.variant, rest = __rest(_a, ["children", "variant"]);
    var cloneChildren = function (_a) {
        var child = _a.child;
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { variant: variant });
        }
        return new Error('Chidren must be a valid element');
    };
    return (React.createElement(StyledGroup, __assign({ className: "sa-label-value-group " + (variant === 'horizontal' ? 'sa-label-value-group-horizontal' : '') + " " + (variant === 'vertical' ? 'sa-label-value-group-vertical' : '') }, rest), React.Children.map(children, function (child) { return child && cloneChildren({ child: child }); })));
}
export function SALabelValue(_a) {
    var label = _a.label, children = _a.children, variant = _a.variant;
    if (variant === 'vertical') {
        return (React.createElement(LabelValueVertical, { label: label, "data-testid": "LabelValueWrapper" }, React.Children.map(children, function (child) {
            return React.createElement(SAText, { "data-testid": "LabelValueItem" }, child);
        })));
    }
    return React.createElement(LabelValueHorizontal, { label: label }, children);
}
SALabelValue.defaultProps = { variant: undefined };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=labelvalue.component.js.map